/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { checkForNumericEnFaString, enToPersianChar, getParameterByName, isValidEmailStrictly, persianToEnglishChar, timingFunction, customTrim } from '../../../../../components/helper'
import { useDispatch } from 'react-redux'
import { checkExistEmail, getCareerField, loginUser, registerUser, resetLoginProps } from '../../../../../service/actions/authActions'
import { useSelector } from 'react-redux'
import { Formik, Field, ErrorMessage, FormikValues, FormikHelpers, Form, useFormik } from 'formik';

import * as Yup from 'yup';
import { CCol, CForm, CRow, CSpinner } from '@coreui/react'
import { CheckBoldSVG, CloseEyeSVG, EyeSVG } from '../../../../../components/IconSvg'
import { types } from '../../../../../service/types'
import { postUpdateUser } from '../../../../../service/reactQueryServices/userService'
import { useMutation } from 'react-query'
import { checkExistEmailByCustomerIdRequestAction } from '../../../../../service/actions/authAction'
import { toast } from 'react-toastify'
import { resetInvoiceAction, resetPurchasePropsAction } from '../../../../../service/actions/purchaseActions'

type Career = {
    id: string,
    title: string
}



const UserInfo = () => {
    const careerList = useSelector((state: any) => state.authReducer.Career)
    const [states, setStates] = CustomValuesHook({})
    const [formState, setFormState] = CustomValuesHook({ displayPassword: true })
    const [userInfo, setUserInfo] = CustomValuesHook({
        Gender: undefined, Mobile: "", Email: "", CareerFieldId: "", OtherCareerField: "", Password: "",
        LastName: "",
        FirstName: "",
    })
    const getIsEmailExistSuccess = useSelector((state: any) => state.tsAuthReducer.checkExistEmailByCustomerIdSuccess)
    const getIsEmailExistResult = useSelector((state: any) => state.tsAuthReducer.checkExistEmailByCustomerIdResponse)
    const getIsEmailExistPending = useSelector((state: any) => state.tsAuthReducer.checkExistEmailByCustomerIdPending)
    const successRegister = useSelector((state: any) => state.authReducer.SuccessRegister)
    const registerResult = useSelector((state: any) => state.authReducer.registerResult)
    const waitingRegister = useSelector((state: any) => state.authReducer.WaitingRegister)
    const waitingLogin = useSelector((state: any) => state.authReducer.WaitingLogin)
    const { mutateAsync: submitUpdate, isLoading } = useMutation("persian-holidays", postUpdateUser);

    const successLogin = useSelector((state: any) => state.authReducer.SuccessLogin)
    const logedInUser = useSelector((state: any) => state.authReducer.User)

    const [isTyping, setIsTyping] = useState()





    const formRef = useRef<any>(null);
    const params = useParams()
    const navigate = useNavigate()
    const location = useLocation()


    const dispatch = useDispatch()
    const validation = Yup.object({
        FirstName: Yup.string().required("وارد کردن نام الزامی است."),
        LastName: Yup.string().required("وارد کردن نام خانوادگی الزامی است."),
        Gender: Yup.string().required("انتخاب جنسیت الزامی است."),
        Mobile: Yup.string().required("وارد کردن شماره تلفن همراه الزامی است."),
        Email: Yup.string().required("وارد کردن پست الکترونیک الزامی است.")
            .test("isExist", "", function (value: any) {
                if (formState.email !== value) {
                    setFormState({ email: customTrim(value) })

                    if (isValidEmailStrictly(customTrim(value))) {
                        if (!getIsEmailExistPending) {
                            timingFunction(setIsTyping, isTyping, function () {
                                dispatch(checkExistEmailByCustomerIdRequestAction({ Email: customTrim(value), CustomerId: "" }))

                            })
                        }

                    }
                }
                return true
            }),
        Password: Yup.string().required("وارد کردن کلمه عبور الزامی است.").min(6, "رمز عبور می‌بایست حداقل شامل 6 کاراکتر باشد."),
        CareerFieldId: Yup.string().required("وارد کردن زمینه فعالیت الزامی است."),


    })

    const handleSubmit = (_values: any) => {
        if (!formik.isValid || (formState.displayOtherCareer && !formik.values.OtherCareerField)) {
            return
        }

        if (!formState.phoneNumberError && getIsEmailExistSuccess && (!getIsEmailExistResult.Value || (location.state?.CustomerId && location?.state?.userInfo.Email === formik.values.Email))
        ) {
            const params = { ..._values, Mobile: persianToEnglishChar(_values.Mobile), Email: customTrim(_values.Email) }
            setUserInfo({ ...params })
            setStates({ userInfo: { ...params } })
            if (location?.state?.CustomerId) {
                handleUpdateUser()
            } else {

                let _tmp={...params}
if(formik?.values?.CareerFieldId==="null") _tmp.CareerFieldId=null

                dispatch(registerUser(_tmp))
            }
        }



    }

    const handleUpdateUser = async () => {

        try {
            const response = await submitUpdate({
                Gender: formik.values.Gender,
                Mobile: formik.values.Mobile,
                Email: customTrim(formik.values.Email),
                CareerFieldId: formik.values.CareerFieldId,
                OtherCareerField: formik.values.OtherCareerField,
                Password: formik.values.Password,
                LastName: formik.values.LastName,
                FirstName: formik.values.FirstName,
                CustomerId: location.state?.CustomerId
            })
            if (response?.Status === 8) {
                if (customTrim(formik.values.Email) !== customTrim(location.state?.userInfo?.Email) ||
                    formik.values.Password !== location.state?.userInfo?.Password
                ) {
                    dispatch(loginUser({
                        username: customTrim(formik.values.Email),
                        password: formik.values.Password,
                        grant_type: 'password'

                    }))
                } else {
                    navigate(`/landingPurchase/step-2/${params.productType}/${params.productId}/${params.contractTypeId}` + location.search, {
                        state: {
                            ...states,
                            userInfo: { ...formik.values }
                        }
                    })
                }
            }

        } catch (error) {

        }
    }
    const validate = (values: any) => {


        if (values?.Mobile && values?.Mobile !== "") {
            let mobile = values.Mobile
            if (checkForNumericEnFaString(values.Mobile)) {
                mobile = persianToEnglishChar(values.Mobile)
            }

            if (!/^(?:(\u0660\u0669[\u0660-\u0669][\u0660-\u0669]{8})|(\u06F0\u06F9[\u06F0-\u06F9][\u06F0-\u06F9]{8})|(09[0-9][0-9]{8}))$/.test(mobile)) {
                return { Mobile: "شماره موبایل وارد شده اشتباه است" }

            }
        }
    }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: userInfo,
        onSubmit: handleSubmit,
        validate,
    })

    useEffect(() => {
        dispatch(resetInvoiceAction())
        dispatch(resetPurchasePropsAction())
        if (!location.state?.productId && (!params?.productId || !params?.contractTypeId || !params?.productType)) {
            toast.error("لینکی که با آن وارد شدید معتبر نمی باشد");
            setTimeout(() => {
                window.location.href = "https://daftareshoma.com"
            }, 5000)
        }
        dispatch(getCareerField())
        if (location?.state?.userInfo) {
            formik.setFieldValue("Password", location?.state?.userInfo.Password);
            formik.setFieldValue("Mobile", location?.state?.userInfo.Mobile);
            formik.setFieldValue("Email", customTrim(location?.state?.userInfo.Email));
            formik.setFieldValue("FirstName", location?.state?.userInfo.FirstName);
            formik.setFieldValue("LastName", location?.state?.userInfo.LastName);
            formik.setFieldValue("Gender", location?.state?.userInfo.Gender);
            formik.setFieldValue("CareerFieldId", location?.state?.userInfo.CareerFieldId);
            formik.setFieldValue("OtherCareerField", location?.state?.userInfo.OtherCareerField);

            setStates({ ...location?.state })

        }
        if (!location?.state?.productId) {

            let state = {
                utm_source: getParameterByName('utm_source'),
                utm_medium: getParameterByName('utm_medium'),
                utm_term: getParameterByName('utm_term'),
                utm_campaign: getParameterByName('utm_campaign'),
                referrer: getParameterByName('utms'),
                urlSearch: location.search,
                contractTypeId: params.contractTypeId,
                productId: params.productId,
                productType: params.productType
            }
            setStates({ ...state })
        }

    }, [])


    useEffect(() => {

        if (formik.values?.CareerFieldId === "null") {
            setFormState({ displayOtherCareer: true })
        } else {
            setFormState({ displayOtherCareer: false })

        }
        if (successRegister) {

            setStates({ CustomerId: registerResult.customerId })
            dispatch({ type: types.REGISTER_USER_RESET_PROPS })
            dispatch(loginUser({
                username: customTrim(userInfo.Email),
                password: userInfo.Password,
                grant_type: 'password'

            }))
        }

        if (successLogin) {
            dispatch(resetLoginProps())

            localStorage.setItem("token", logedInUser.access_token)
            localStorage.setItem("portalExtraInfo", JSON.stringify(logedInUser?.ExtraInfo))
            localStorage.setItem("dsTokenExpiration", logedInUser?.expires_in?.toString())

            navigate(`/landingPurchase/step-2/${params.productType}/${params.productId}/${params.contractTypeId}` + location.search, {
                state: {
                    ...states,
                    userInfo: { ...userInfo }
                }
            })
        }
    }, [formik.values?.CareerFieldId, successRegister, successLogin])






    return (
        <div className='user-form' >
            <h3 className="block mt-5">اطلاعات کاربری</h3>

            لطفا جهت تکمیل درخواست خود، فرم زیر را کامل و روی دکمه "مرحله بعد" کلیک کنید.
            <CRow>
                <CCol lg={12} xs={12} className='mt-3 form-horizontal'>
                    {/* <Formik initialValues={{ ...userInfo }} onSubmit={handleSubmit} validationSchema={validation} innerRef={formRef} > */}
                    <CForm onSubmit={formik.handleSubmit} >
                        <div className='form-item row mt-3' >
                            <label className='col-md-3'>نام: <span>*</span> </label>
                            <div className='col-md-12 col-lg-4 col-sm-12 col-xs-12' >
                                {formik.touched.FirstName}
                                <input type='text'
                                    name="FirstName"
                                    id='FirstName'
                                    value={formik.values.FirstName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className='form-control' />
                                {formik.errors.FirstName && formik.touched.FirstName && <label className='label-danger '>{formik.errors.FirstName}</label>}
                            </div>
                        </div>
                        <div className='form-item row mt-3' >
                            <label className='col-md-3'>نام خانوادگی: <span>*</span> </label>
                            <div className='col-md-12 col-lg-4 col-sm-12 col-xs-12' >
                                <input type='text' name="LastName"
                                    value={formik.values.LastName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className='form-control' />
                                {formik.errors.LastName && formik.touched.LastName && <label className='label-danger '>{formik.errors.LastName}</label>}

                            </div>
                        </div>
                        <div className='form-item row mt-3' >
                            <label className='col-md-3'>جنسیت: <span>*</span> </label>
                            <div className='col-md-12 col-lg-4 col-sm-12 col-xs-12 ' >
                                {/* <select name="Gender"
                                    value={formik.values.Gender}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className='form-select' >
                                    {(!formik.values.Gender) && <option>یک گزینه انتخاب کنید</option>}
                                    <option value={'1'}>زن</option>
                                    <option value={'2'}>مرد</option>

                                </select> */}
                                <div className='d-flex' >
                                    <label className='me-2' >
                                        <input type="radio" name="Gender"
                                            checked={formik.values.Gender === "1"}
                                            className='mx-1' value="1"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur} />
                                        زن
                                    </label>
                                    <label>
                                        <input type="radio" name="Gender"
                                            checked={formik.values.Gender === "2"}
                                            className='mx-1' value="2"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur} />
                                        مرد
                                    </label>
                                </div>
                                <div> {formik.errors.Gender && formik.touched.Gender && <label className='label-danger '>{formik.errors.Gender}</label>}</div>


                            </div>
                        </div>
                        <div className='form-item row mt-3' >
                            <label className='col-md-3'>تلفن همراه: <span>*</span> </label>
                            <div className='col-md-12 col-lg-4 col-sm-12 col-xs-12' >
                                <input type='text' name="Mobile"
                                    value={formik.values.Mobile}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className='form-control' />
                                {formik.errors.Mobile && formik.touched.Mobile && <label className='label-danger '>{formik.errors.Mobile}</label>}

                                {formState.phoneNumberError && !formik.errors.Mobile && <label className='label-danger' >
                                    شماره موبایل وارد شده اشتباه است

                                </label >}
                            </div>
                        </div>
                        <div className='form-item row mt-3' >
                            <label className='col-md-3'>پست الکترونیک: <span>*</span> </label>
                            <div className='col-md-12 col-lg-4 col-sm-12 col-xs-12' >
                                <div className='email-container' >
                                    <input type='text' name="Email" id="newEmail"
                                        value={formik.values.Email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        autoComplete='newEmail'
                                        className='form-control' />
                                    {getIsEmailExistSuccess && (!getIsEmailExistResult.Value || (location.state?.CustomerId && customTrim(location?.state?.userInfo.Email) === customTrim(formik.values.Email))) && customTrim(formik.values.Email) && isValidEmailStrictly(customTrim(formik.values.Email)) &&
                                        <span className='sp-success'>
                                            <CheckBoldSVG fill='#1B9E3E' /></span>}

                                    {getIsEmailExistPending && <span className='sp-pending'><CSpinner size="sm" color="dark" /></span>}
                                </div>

                                {formik.errors.Email && formik.touched.Email && <label className='label-danger '>{formik.errors.Email}</label>}
                                {(!isValidEmailStrictly(customTrim(formik.values.Email)) && formik.touched.Email && !formik.errors.Email) ? <label className='label-danger '>ایمیل  نامعتبر است </label> : ((getIsEmailExistSuccess && getIsEmailExistResult?.Value && !location?.state?.CustomerId) || (getIsEmailExistSuccess && getIsEmailExistResult.Value && location?.state?.CustomerId && (customTrim(formik.values.Email) !== customTrim(location?.state?.userInfo.Email)))) &&
                                    !formik.errors.Email ? <label className='label-danger is-email-exist-error' >
                                    ایمیل در سیستم وجود دارد، لطفا وارد شوید
                                    <Link to="/login" >ورود به پرتال</Link>
                                </label > : ""}


                            </div>
                        </div>
                        <div className='form-item row mt-3' >
                            <label className='col-md-3'>کلمه عبور: <span>*</span> </label>
                            <div className='col-md-12 col-lg-4 col-sm-12 col-xs-12' >
                                <div className='password-container' >
                                    <input type={formState.displayPassword ? 'password' : 'text'}
                                        name="Password"
                                        value={formik.values.Password}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        autoComplete='new-password'
                                        className='form-control' />
                                    {formik.errors.Password && formik.touched.Password && <label className='label-danger '>{formik.errors.Password}</label>}

                                    <span onClick={() => setFormState({ displayPassword: !formState.displayPassword })}>
                                        {!formState.displayPassword ? <CloseEyeSVG /> : <EyeSVG />}
                                    </span>
                                </div>


                            </div>
                        </div>
                        <div className='form-item row mt-3' >
                            <label className='col-md-3'>زمینه فعالیت: <span>*</span> </label>
                            <div className='col-md-12 col-lg-4 col-sm-12 col-xs-12' >
                                <select name="CareerFieldId"
                                    className='form-select'
                                    value={formik.values.CareerFieldId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    {!formik.values.CareerFieldId && <option value="">یک گزینه انتخاب کنید</option>}
                                    {careerList?.map((item: Career, idx: number) => <option value={item.id} key={idx}>{item.title}</option>)}
                                    <option value="null">سایر...</option>


                                </select>
                                {formik.errors.CareerFieldId && formik.touched.CareerFieldId && <label className='label-danger '>{formik.errors.CareerFieldId}</label>}

                                {formState.displayOtherCareer &&
                                    <>
                                        <input type='text' name="OtherCareerField"
                                            placeholder="زمینه فعالیت خود را وارد کنید"
                                            value={formik.values.OtherCareerField}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className='form-control mt-2' />
                                        {!formik?.values?.OtherCareerField && <label className='label-danger' >
                                            زمینه فعالیت را وارد کنید.

                                        </label >}
                                    </>
                                }
                            </div>
                        </div>
                        <div className='d-flex justify-content-end mt-5'>
                            <button type='submit' disabled={
                                waitingRegister || isLoading || waitingLogin


                            } className='btn btn-info' >مرحله بعد
                                {(waitingRegister || waitingLogin || isLoading) && <CSpinner size="sm" color="light" />}

                            </button>

                        </div>
                    </CForm>
                    {/* </Formik> */}
                </CCol>
            </CRow>


        </div>
    )
}

export default UserInfo


